import type { AdminRole } from '@/lib/api-admin';

/**
 * 환율 설정 RBAC. 환율은 전사 가격에 영향을 주는 민감 설정이라 쓰기는 OPS 이상으로 제한한다.
 * 읽기는 가격을 다루는 MD_MANAGER 까지 허용. (be-rate 컨트롤러 @PreAuthorize 와 정합 확인 필요.)
 */
export const EXCHANGE_RATE_READ_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
  'MD_MANAGER',
];

export const EXCHANGE_RATE_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
